<div class="handler border-width-more active border-primary border-radius"></div>
